import {Pipe, PipeTransform} from '@angular/core';
import {isAfter, isBefore} from 'date-fns';
import {LabelDataDto} from '../../../Models/YuChef/Labeled/labeled.interface';

@Pipe({
  name: 'labeled',
  standalone: false
})
export class LabeledPipe implements PipeTransform {

  transform(items: LabelDataDto[], state: string, filters: { menu: string, id_familia?: number[] }): LabelDataDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    const now = new Date();

    if (filters.id_familia && filters.id_familia.length > 0) {
      items = items.filter((item) => filters.id_familia?.includes(item['id_familia']));
    }

    if (filters.menu === 'favorites') {
      items = items.filter((item) => item['favorito']);
    }

    if (filters.menu === 'caducados' || state === 'danger') {
      items = items.filter((item) => item['fecha_caducidad'] && isAfter(now, new Date(item['fecha_caducidad'])));
    }

    if (state === 'success') {
      items = items.filter((item) => !item['fecha_caducidad'] || isBefore(now, new Date(item['fecha_caducidad'])));
    }

    return items;

  }

}
